(() => {
  document.addEventListener('click', (event) => {
    const section = event.target.closest('[data-gr-filter-scope]') || document;
    const panel = section.querySelector('[data-gr-filter-panel]');

    if (event.target.closest('[data-gr-filter-open]')) panel?.classList.add('is-open');
    if (event.target.closest('[data-gr-filter-close]')) panel?.classList.remove('is-open');
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      document.querySelectorAll('[data-gr-filter-panel].is-open').forEach((panel) => panel.classList.remove('is-open'));
    }
  });

  document.addEventListener('change', (event) => {
    const form = event.target.closest('[data-gr-global-filter-form]');
    if (form && event.target.matches('input')) form.submit();

    if (event.target.matches('#SortBy')) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      window.location.assign(url.toString());
    }
  });
})();
